import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import VodNav from './js/vod-nav.component';
import { vodeNavEvents, vodNavModeTypes } from './js/enums';

ComponentsFactory.getInstance().define('vod-nav', VodNav);

export { vodeNavEvents, vodNavModeTypes };
